import React from 'react';
import FeedViewComponent from 'components/FeedViewComponent/web';

const FeedViewWebPage = () => {
  return <FeedViewComponent />;
};

export default FeedViewWebPage;
